import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { RegisterPeerReviewerRequest } from '../../models/super-admin/registerPeerReviewerRequest';
import { Observable } from 'rxjs';
import { PeerReviewerResponse } from '../../models/super-admin/peerReviewerResponse';
import { GetPeerReviewerRequest } from '../../models/super-admin/getPeerReviewerRequest';
import { apiResponse } from '../../models/apiResponse';
import { UpdatePeerReviewerStateRequest } from '../../models/super-admin/updatePeerReviewerStateRequest';
import { PeerReviewersTimingsAndScheduledCallsRequest } from '../../models/super-admin/peerReviewersTimingsAndScheduledCallsRequest';
import { PeerReviewersTimingsAndScheduledCallsResponse } from '../../models/super-admin/peerReviewersTimingsAndScheduledCallsResponse';
import { UpdatePeerReviewerRequest } from '../../models/super-admin/updatePeerReviewerRequest';

@Injectable({
  providedIn: 'root'
})
export class PeerReviewService {

  constructor(private genericService: GenericService) { }

  registerPeerReviewer(registerPeerReviewerRequest: RegisterPeerReviewerRequest): Observable<PeerReviewerResponse> {
    const documentData = new FormData();
    documentData.append('firstName', registerPeerReviewerRequest.firstName ?? '');
    documentData.append('lastName', registerPeerReviewerRequest.lastName ?? '');
    documentData.append('gender', registerPeerReviewerRequest.gender.toString());
    documentData.append('email', registerPeerReviewerRequest.email ?? '');
    documentData.append('linkedInProfileUrl', registerPeerReviewerRequest.linkedInProfileUrl ?? '');
    documentData.append('phoneNumber', registerPeerReviewerRequest.phoneNumber ?? '');
    if (registerPeerReviewerRequest.imageUrl) {
      documentData.append('imageUrl', registerPeerReviewerRequest.imageUrl, registerPeerReviewerRequest.imageUrl.name);
    }
    documentData.append('city', registerPeerReviewerRequest.city ?? '');
    documentData.append('country', registerPeerReviewerRequest.country ?? '');
    documentData.append('homeCity', registerPeerReviewerRequest.homeCity ?? '');
    documentData.append('homeCountry', registerPeerReviewerRequest.homeCountry ?? '');
    documentData.append('highSchoolName', registerPeerReviewerRequest.highSchoolName ?? '');
    documentData.append('highSchoolBoard', registerPeerReviewerRequest.highSchoolBoard ?? '');
    documentData.append('highSchoolCompletionYear', registerPeerReviewerRequest.highSchoolCompletionYear ?? '');
    documentData.append('tenthGrades', registerPeerReviewerRequest.tenthGrades ?? '');
    documentData.append('twelvethGrades', registerPeerReviewerRequest.twelvethGrades ?? '');
    documentData.append('courseWork', registerPeerReviewerRequest.courseWork ?? '');
    documentData.append('highestLevelEducation', registerPeerReviewerRequest.highestLevelEducation ?? '');
    documentData.append('underGraduateCollageName', registerPeerReviewerRequest.underGraduateCollageName ?? '');
    documentData.append('underGraduateCollageCountry', registerPeerReviewerRequest.underGraduateCollageCountry ?? '');
    documentData.append('underGraduateCollageCity', registerPeerReviewerRequest.underGraduateCollageCity ?? '');
    documentData.append('underGraduateMajorOrDegree', registerPeerReviewerRequest.underGraduateMajorOrDegree ?? '');
    documentData.append('underGraduateOrExpectedUnderGraduationCompletionYear', registerPeerReviewerRequest.underGraduateOrExpectedUnderGraduationCompletionYear ?? '');
    documentData.append('underGraduateExpectedGrades', registerPeerReviewerRequest.underGraduateExpectedGrades ?? '');
    documentData.append('underGraduateDegreeAndClass', registerPeerReviewerRequest.underGraduateDegreeAndClass ?? '');
    documentData.append('graduateCollageName', registerPeerReviewerRequest.graduateCollageName ?? '');
    documentData.append('graduateCollageCountry', registerPeerReviewerRequest.graduateCollageCountry ?? '');
    documentData.append('graduateCollageCity', registerPeerReviewerRequest.graduateCollageCity ?? '');
    documentData.append('graduateMajorOrDegree', registerPeerReviewerRequest.graduateMajorOrDegree ?? '');
    documentData.append('graduateOrExpectedGraduationCompletionYear', registerPeerReviewerRequest.graduateOrExpectedGraduationCompletionYear ?? '');
    documentData.append('graduateExpectedGrades', registerPeerReviewerRequest.graduateExpectedGrades ?? '');
    documentData.append('satOverallScore', registerPeerReviewerRequest.satOverallScore ?? '');
    documentData.append('satMathScore', registerPeerReviewerRequest.satMathScore ?? '');
    documentData.append('satEnglishScore', registerPeerReviewerRequest.satEnglishScore ?? '');
    documentData.append('actOverallScore', registerPeerReviewerRequest.actOverallScore ?? '');
    documentData.append('actEnglishScore', registerPeerReviewerRequest.actEnglishScore ?? '');
    documentData.append('actMathScore', registerPeerReviewerRequest.actMathScore ?? '');
    documentData.append('greScore', registerPeerReviewerRequest.greScore ?? '');
    documentData.append('greVerbalScore', registerPeerReviewerRequest.greVerbalScore ?? '');
    documentData.append('greQuantitativeScore', registerPeerReviewerRequest.greQuantitativeScore ?? '');
    documentData.append('gmatScore', registerPeerReviewerRequest.gmatScore ?? '');
    documentData.append('gmatSubScore', registerPeerReviewerRequest.gmatSubScore ?? '');
    documentData.append('workExperienceBeforeMBA', registerPeerReviewerRequest.workExperienceBeforeMBA ?? '');
    documentData.append('graduateIeltsScore', registerPeerReviewerRequest.graduateIeltsScore ?? '');
    documentData.append('graduateToeflScore', registerPeerReviewerRequest.graduateToeflScore ?? '');
    documentData.append('ieltsScore', registerPeerReviewerRequest.ieltsScore ?? '');
    documentData.append('toeflScore', registerPeerReviewerRequest.toeflScore ?? '');
    documentData.append('apScore', registerPeerReviewerRequest.apScore ?? '');
    documentData.append('extraCurricularActivitiesDescription', registerPeerReviewerRequest.extraCurricularActivitiesDescription ?? '');
    documentData.append('shortBio', registerPeerReviewerRequest.shortBio ?? '');
    documentData.append('scholarshipsAndAchievements', registerPeerReviewerRequest.scholarshipsAndAchievements ?? '');
    // ASP.NET binds FormData arrays via repeated keys: speakingCareerAreas=1&speakingCareerAreas=8
    (registerPeerReviewerRequest.speakingCareerAreas ?? []).forEach(area => {
      documentData.append('speakingCareerAreas', area.toString());
    });
    documentData.append('employmentHistory', JSON.stringify(registerPeerReviewerRequest.employmentHistory));
    documentData.append('state', registerPeerReviewerRequest.state.toString());

    return this.genericService.post(`peerreviewer/register`, documentData);
  }
  getAllPeerReviewers(getPeerReviewerRequest: GetPeerReviewerRequest): Observable<apiResponse<PeerReviewerResponse[]>> {
    return this.genericService.post(`peerreviewer`, getPeerReviewerRequest);
  }
  getPeerReviewerDetailsByAdmin(peerReviewersTimingsAndScheduledCallsRequest: PeerReviewersTimingsAndScheduledCallsRequest): Observable<apiResponse<PeerReviewersTimingsAndScheduledCallsResponse[]>> {
    return this.genericService.post(`peerreviewerbyadmin`, peerReviewersTimingsAndScheduledCallsRequest);
  }
  getPeerReviewerById(peerId?: string): Observable<PeerReviewerResponse> {
    return this.genericService.get(`peerreviewer/${peerId}`);
  }
  updatePeerReviewer(updatePeerReviewerRequest: UpdatePeerReviewerStateRequest): Observable<PeerReviewerResponse> {
    return this.genericService.patch(`peerreviewer`, updatePeerReviewerRequest);
  }
  updatePeerReviewerDetails(req: UpdatePeerReviewerRequest): Observable<PeerReviewerResponse> {
    const documentData = new FormData();
    documentData.append('applicationUserId', req.applicationUserId ?? '');
    documentData.append('firstName', req.firstName ?? '');
    documentData.append('lastName', req.lastName ?? '');
    documentData.append('gender', req.gender.toString());
    documentData.append('linkedInProfileUrl', req.linkedInProfileUrl ?? '');
    documentData.append('phoneNumber', req.phoneNumber ?? '');
    if (req.imageUrl) {
      documentData.append('imageUrl', req.imageUrl, req.imageUrl.name);
    }
    documentData.append('city', req.city ?? '');
    documentData.append('country', req.country ?? '');
    documentData.append('homeCity', req.homeCity ?? '');
    documentData.append('homeCountry', req.homeCountry ?? '');
    documentData.append('highestLevelEducation', req.highestLevelEducation ?? '');
    documentData.append('highSchoolName', req.highSchoolName ?? '');
    documentData.append('highSchoolBoard', req.highSchoolBoard ?? '');
    documentData.append('highSchoolCompletionYear', req.highSchoolCompletionYear ?? '');
    documentData.append('tenthGrades', req.tenthGrades ?? '');
    documentData.append('twelvethGrades', req.twelvethGrades ?? '');
    documentData.append('courseWork', req.courseWork ?? '');
    documentData.append('underGraduateCollageName', req.underGraduateCollageName ?? '');
    documentData.append('underGraduateCollageCountry', req.underGraduateCollageCountry ?? '');
    documentData.append('underGraduateCollageCity', req.underGraduateCollageCity ?? '');
    documentData.append('underGraduateMajorOrDegree', req.underGraduateMajorOrDegree ?? '');
    documentData.append('underGraduateOrExpectedUnderGraduationCompletionYear', req.underGraduateOrExpectedUnderGraduationCompletionYear ?? '');
    documentData.append('underGraduateExpectedGrades', req.underGraduateExpectedGrades ?? '');
    documentData.append('underGraduateDegreeAndClass', req.underGraduateDegreeAndClass ?? '');
    documentData.append('graduateCollageName', req.graduateCollageName ?? '');
    documentData.append('graduateCollageCountry', req.graduateCollageCountry ?? '');
    documentData.append('graduateCollageCity', req.graduateCollageCity ?? '');
    documentData.append('graduateMajorOrDegree', req.graduateMajorOrDegree ?? '');
    documentData.append('graduateOrExpectedGraduationCompletionYear', req.graduateOrExpectedGraduationCompletionYear ?? '');
    documentData.append('graduateExpectedGrades', req.graduateExpectedGrades ?? '');
    documentData.append('satOverallScore', req.satOverallScore ?? '');
    documentData.append('satMathScore', req.satMathScore ?? '');
    documentData.append('satEnglishScore', req.satEnglishScore ?? '');
    documentData.append('actOverallScore', req.actOverallScore ?? '');
    documentData.append('actEnglishScore', req.actEnglishScore ?? '');
    documentData.append('actMathScore', req.actMathScore ?? '');
    documentData.append('greScore', req.greScore ?? '');
    documentData.append('greVerbalScore', req.greVerbalScore ?? '');
    documentData.append('greQuantitativeScore', req.greQuantitativeScore ?? '');
    documentData.append('gmatScore', req.gmatScore ?? '');
    documentData.append('gmatSubScore', req.gmatSubScore ?? '');
    documentData.append('workExperienceBeforeMBA', req.workExperienceBeforeMBA ?? '');
    documentData.append('graduateIeltsScore', req.graduateIeltsScore ?? '');
    documentData.append('graduateToeflScore', req.graduateToeflScore ?? '');
    documentData.append('ieltsScore', req.ieltsScore ?? '');
    documentData.append('toeflScore', req.toeflScore ?? '');
    documentData.append('apScore', req.apScore ?? '');
    documentData.append('extraCurricularActivitiesDescription', req.extraCurricularActivitiesDescription ?? '');
    documentData.append('shortBio', req.shortBio ?? '');
    documentData.append('scholarshipsAndAchievements', req.scholarshipsAndAchievements ?? '');
    // ASP.NET binds FormData arrays via repeated keys: speakingCareerAreas=1&speakingCareerAreas=8
    (req.speakingCareerAreas ?? []).forEach(area => {
      documentData.append('speakingCareerAreas', area.toString());
    });
    documentData.append('employmentHistory', JSON.stringify(req.employmentHistory));
    documentData.append('isEmailUpdate', req.isEmailUpdate.toString());
    documentData.append('email', req.email ?? '');
    return this.genericService.put(`peerreviewer`, documentData);
  }

  convertStudentToPeer(studentUserId: string): Observable<apiResponse<PeerReviewerResponse>> {
    return this.genericService.post(`peerreviewer/convert-student/${studentUserId}`, null);
  }
}
